import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import colors from "core/colors";
import BodyText from "core/BodyText";

import { convertPxToRem } from "frontend/components/helpers";

const Container = styled.div`
    display: inline-block;
    height: ${convertPxToRem(20)};
    padding-left: ${convertPxToRem(8)};
    padding-right: ${convertPxToRem(8)};

    outline: ${({ darkMode, badgeStyle }) => {
        if (!darkMode && badgeStyle === "strong") {
            return `1px solid ${colors.accent.lightMode.persian}`;
        } else {
            return "transparent";
        }
    }};

    background-color: ${({ darkMode, badgeStyle }) => {
        if (darkMode) {
            return colors.primary.scheifer;
        } else {
            if (badgeStyle === "strong") {
                return "transparent";
            }

            if (badgeStyle === "muted") {
                return colors.accent.darkMode.suenosBuenos;
            }
        }
    }};
`;

const Badge = ({ darkMode = false, badgeStyle = "strong", children }) => {
    return (
        <Container darkMode={darkMode} badgeStyle={badgeStyle}>
            <BodyText
                size="sm"
                copyColor={
                    !darkMode && badgeStyle === "strong"
                        ? colors.accent.lightMode.persian
                        : colors.secondary.orca
                }
            >
                {children}
            </BodyText>
        </Container>
    );
};

Badge.propTypes = {
    mode: PropTypes.oneOf(["light, dark"]),
    badgeStyle: PropTypes.oneOf(["strong", "muted"])
};

export default Badge;
